import React, { Fragment } from "react";
import PropTypes from "prop-types";
import Resource from "common/components/Resource";
import Panel from "common/components/Panel";
import BusinessForm from "../businessForm";
import actions from "../actions";
import QRCodeModal from "common/components/QRCodeModal";
import ResourceAdmins from "core/ResourceAdmins";
import { transformApiError } from "common/api/errors";
import DownloadCSV from "core/DownloadCSV";

const handleSubmit = (id) => async (values, form, providersData) => {
  const {
    address,
    city,
    community,
    building,
    category,
    country,
    name,
    postal,
    website,
    phone,
    region,
    heroFile,
    logoFile,
    hours,
    keywords,
    active,
    description,
    tenant_id,
  } = values;
  const { setSubmitting, setErrors, setStatus } = form;
  try {
    const body = {
      street_address: address,
      city,
      community_id: community,
      category_id: category,
      primary_phone_number: phone,
      website_url: website,
      hours: JSON.stringify(hours),
      country,
      name,
      postal_code: postal,
      region,
      keywords,
      description,
      active,
      building_id: building,
      food_links: providersData,
      tenant_id,
    };

    await actions.update(id, body);

    await actions.attachFiles(id, [
      {
        prop: "hero_url",
        name: "hero",
        file: heroFile,
      },
      {
        prop: "logo_url",
        name: "logo",
        file: logoFile,
      },
    ]);

    setStatus({ success: true });
  } catch (error) {
    const apiError = transformApiError(error);
    if (apiError.empty()) {
      setErrors({ http: error.message });
    } else {
      setErrors(apiError.object());
    }
  }
  setSubmitting(false);
};

const EditBusiness = ({ match }) => (
  <Resource
    name="businesses"
    resourceId={match.params.id}
    render={(business) => (
      <Fragment>
        <Panel
          title="Edit Business"
          action={<QRCodeModal content={business.redemption_url} />}
          secondaryAction={
            <DownloadCSV
              apiUrl={`businesses/${match.params.id}/download_redemptions`}
              title="Redemptions"
            />
          }
        >
          <BusinessForm
            isEdit
            handleSubmit={handleSubmit(match.params.id)}
            initialValues={{
              name: business.name || "",
              address: business.street_address || "",
              city: business.city || "",
              region: business.region || "",
              country: business.country || "",
              postal: business.postal_code || "",
              community: business.community_id || 0,
              building: business.building_id || 0,
              category: business.category_id || 0,
              phone: business.primary_phone_number || "",
              website: business.website_url || "",
              heroUrl: business.hero_url || "",
              logoUrl: business.logo_url || "",
              hours: business.hours || {},
              keywords: business.keywords || "",
              active: business.active,
              description: business.description || "",
              food_links: business.food_links,
              tenant_id: business.tenant_id || 0,
            }}
          />
        </Panel>
        <ResourceAdmins
          resourceType="business"
          resourceId={parseInt(match.params.id, 10)}
        />
      </Fragment>
    )}
  />
);

EditBusiness.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
};

export default EditBusiness;
